import React from "react";
import "./styles.css";

function AnchorImage({ link, image }) {
  return (
    <a className="anchor-image" target="_blank" rel="noreferrer" href={link}>
      <img src={image} alt="graphic of anchor" />
    </a>
  );
}

export default AnchorImage;
